import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Dashboard from './Dashboard'
import ContactUs from './ContactUs'
import "./App.css";

function App() {
  
    return (
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </Router>
    );
}

export default App;